export enum BusinessArea {
    All = 'Alla',
    Hot = 'Fjärrvärme',
    Cold = 'Fjärrkyla'
  }
  